import * as React from 'react'
import { observer } from 'mobx-react'
import { PayoutDraftingViewModel } from 'payouts/admin/review/PayoutDraftingViewModel'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'
import Button from 'components/Button'
import { Amount } from 'payouts/components/Amount'
import styles from './DraftingView.sass'

/**
 * Confirm Payout Modal
 */
export const ConfirmPayoutModal = observer(function ConfirmPayoutModal({
  vm,
}: {
  vm: PayoutDraftingViewModel
}) {
  return (
    <ModalSheet
      showing={vm.confirmSubmitVM.showing}
      onRequestClose={vm.confirmSubmitVM.close}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_manage-billing.svg')}
          />
          <ModalSheetContentTitle>
            Are you sure you want to issue the payout?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            You are about to issue a{' '}
            <Emphasize>
              <Amount value={vm.total} />
            </Emphasize>{' '}
            payout consisting of{' '}
            <Emphasize>{vm.approvedTransactions.length} transactions</Emphasize>
            . Please double check your approved transactions before proceeding.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.confirmSubmitVM.close}>Cancel</Button>
          <Button type="primary" onClick={vm.confirmSubmitVM.confirm}>
            Issue Payout
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

/**
 * Emphasize
 */
export function Emphasize({ children }: { children?: React.ReactNode }) {
  return <span className={styles.emphasize}>{children}</span>
}
